module.exports = __webpack_public_path__ + "img/sld_mfm_dark.8d15887b.svg";